import { useMutation, useQueryClient } from '@tanstack/react-query'

import { getServerLikesActive } from '@wwt/core/admin'

import { assert } from '@/shared/lib/assert.ts'

import { SetTypes, setKeys } from '../config/setKeys.ts'
import { deleteSetQuery } from '../query/deleteSetQuery.ts'
import { SetMutationUtils } from '../utils/setMutationUtils.ts'

export const useDeleteSetMutation = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationKey: setKeys.delete(),
		mutationFn: async (id: string) => {
			if (!getServerLikesActive()) return

			// TODO: Remove token usage
			return await deleteSetQuery(id)
		},
		onMutate: id => {
			const keys = {
				sets: setKeys.all()
			}

			queryClient.cancelQueries({ queryKey: keys.sets })

			const previousSets = queryClient.getQueryData<SetTypes['all']>(keys.sets)

			queryClient.setQueryData<SetTypes['all']>(keys.sets, saved =>
				SetMutationUtils.removeSetFromList(saved, id)
			)

			return {
				previous: { sets: previousSets },
				keys
			}
		},

		/* prettier-ignore */
		onError: (_err, _title, context) => {
			assert(context !== undefined, 'Context not found in onError on delete set')

			queryClient.setQueryData<SetTypes['all']>(context.keys.sets, context.previous.sets)
		},

		/* prettier-ignore */
		onSuccess: (_data, _title, context) => {
			assert(context !== undefined, 'Context not found in onSuccess on delete set')

			// Q: We need this?
			// We invalidate sets for prevent errors when on server something went wrong with set deletion  
			queryClient.invalidateQueries({ queryKey: context.keys.sets })
		}
	})

	return mutation
}
